module.exports = function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
};



//////////////////
// WEBPACK FOOTER
// ./~/coact/~/ramda/src/internal/_isObject.js
// module id = 1466
// module chunks = 0